import { apiClient } from "@/shared/api/client";
import type {
  AddFavouritePayload,
  Favourite,
  FavouriteList,
} from "@/features/favourites/types";

export async function listFavourites(): Promise<Favourite[]> {
  const { data } = await apiClient.get<FavouriteList>("/favourites");
  return data.favourites;
}

export async function addFavourite(payload: AddFavouritePayload): Promise<Favourite> {
  const { data } = await apiClient.post<Favourite>("/favourites", payload);
  return data;
}

export async function updateFavourite(
  favouriteId: string,
  notes: string | null,
): Promise<Favourite> {
  const { data } = await apiClient.patch<Favourite>(`/favourites/${favouriteId}`, {
    notes,
  });
  return data;
}

export async function removeFavourite(workerId: string): Promise<void> {
  await apiClient.delete(`/favourites/${workerId}`);
}
